import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PhoneCall, PhoneOff, Activity, ClipboardCheck, CalendarClock } from "lucide-react";
import { StatCard, BarRow } from "./DashBits";
import WidgetExport from "./WidgetExport";
export default function CallingTab({ data, drill }) {
  const buckets = data.attempts.buckets;
  const totalLeads = data.progress.total;
  const oc = data.outcomes;
  const daily = data.daily;
  return (
    <div className="space-y-4" data-testid="dash-tab-calling">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        <StatCard label="Avg Attempts / Lead" value={data.attempts.avg} icon={Activity} testid="kpi-avg-attempts" />
        <StatCard label="Total Calls Logged" value={oc.total_calls} icon={PhoneCall} accent="text-sky-600" testid="kpi-total-calls" />
        <StatCard label="Connected" value={oc.connected} icon={PhoneCall} accent="text-emerald-600" testid="kpi-connected" />
        <StatCard label="Not Connected" value={oc.not_connected} icon={PhoneOff} accent="text-rose-600" testid="kpi-not-connected" />
        <StatCard label="Calls Today" value={daily.calls_today} icon={PhoneCall} accent="text-purple-600" testid="kpi-calls-today" />
        <StatCard label="Captured Today" value={daily.captured_today} icon={ClipboardCheck} accent="text-emerald-600" testid="kpi-captured-today" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <Card>
          <CardHeader className="pb-2 flex flex-row items-center justify-between">
            <CardTitle className="text-sm">Call Attempts per Lead</CardTitle>
            <WidgetExport title="Call Attempts" headers={["Attempts", "Leads"]}
                          getRows={() => ["0", "1", "2", "3", "4", "5+"].map((b) => [b, buckets[b] || 0])} />
          </CardHeader>
          <CardContent className="space-y-1.5" data-testid="attempts-card">
            {["0", "1", "2", "3", "4", "5+"].map((b) => (
              <BarRow key={b} label={b === "0" ? "0 attempts" : b === "5+" ? "5+ attempts" : `${b} attempt${b === "1" ? "" : "s"}`}
                      count={buckets[b] || 0} total={totalLeads} color={b === "0" ? "#CBD5E1" : "#6366F1"}
                      onClick={() => drill({ attempts: b })} testid={`attempts-bucket-${b}`} />
            ))}
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="pb-2 flex flex-row items-center justify-between">
            <CardTitle className="text-sm">Call Outcomes</CardTitle>
            <WidgetExport title="Call Outcomes" headers={["Outcome", "Code", "Count"]}
                          getRows={() => oc.breakdown.map((o) => [o.outcome, o.code || "", o.count])} />
          </CardHeader>
          <CardContent className="space-y-1.5" data-testid="outcomes-card">
            {oc.breakdown.length === 0 && (
              <div className="text-xs text-slate-400">No calls logged yet — import Genesys call logs or start dialing.</div>
            )}
            {oc.breakdown.map((o) => (
              <BarRow key={`${o.outcome}-${o.code}`} label={o.outcome} count={o.count} total={oc.total_calls}
                      color={o.code === "DC" ? "#059669" : o.code === "WN" ? "#B91C1C" : o.code ? "#0284C7" : "#94A3B8"}
                      onClick={o.code ? () => drill({ disposition: o.code }) : undefined}
                      testid={`outcome-${o.outcome.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`} />
            ))}
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader className="pb-2"><CardTitle className="text-sm flex items-center gap-2">
          <CalendarClock className="w-4 h-4 text-amber-600" /> Today's Progress
        </CardTitle></CardHeader>
        <CardContent className="grid grid-cols-2 sm:grid-cols-4 gap-3" data-testid="daily-card">
          {[["Leads worked", daily.worked_today], ["Calls made", daily.calls_today],
            ["Data captured", daily.captured_today], ["Callbacks scheduled", daily.callbacks_today]]
            .map(([label, v]) => (
              <div key={label} className="rounded border border-slate-100 p-3 text-center">
                <div className="text-xl font-semibold text-slate-900">{v}</div>
                <div className="text-[10px] uppercase tracking-wider text-slate-400">{label}</div>
              </div>
            ))}
        </CardContent>
      </Card>
    </div>
  );
}
